import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import merge from "lodash/merge";
import { css, ThemedCssFunction } from "styled-components";

export default (themeConfig: any): ThemedCssFunction<BaseTheme> => {
    let props = { theme: merge({}, baseTheme, themeConfig) };

    return (first: any, ...interpolations: any): any => css`
        ${x => {
            if (x) {
                props = x;
            }
            return null;
        }}
        ${css(first, ...interpolations)
            .map(x => {
                return typeof x === "function" ? (x as any)(props) : x;
            })
            .join("")}
    `;
};
